import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Event.css';
import EditIcon from '../assets/images/edit.svg';
import DeleteIcon from '../assets/images/delete.svg';
import { useNavigate } from 'react-router-dom';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

const CreateEventForm = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get('/auth/event/questions');
      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddEvent = () => {
    navigate('/event/new');
  };

  const handleEdit = (event) => {
    navigate(`/event/edit/${event._id}`);
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const confirmDelete = async (id) => {
    try {
      await axios.delete(`/auth/event/questions/${id}`);
      fetchEvents();
      setShowModal(false);
    } catch (error) {
      console.error('Error deleting event:', error);
    }
  };

  const convertLinks = (text) => {
    if (!text) return '';

    return text.replace(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );
  };

  return (
    <div className="event-container">
      {showModal && (
        <div className="confirmation-modal">
          <div className="confirmation-modal-content">
            <p className='title'>Are you sure you want to delete this event?</p>
            <div>
              <button className='yes-btn action-btn' onClick={() => confirmDelete(selectedId)}>Yes</button>
              <button className='no-btn action-btn' onClick={() => setShowModal(false)}>No</button>
            </div>
          </div>
        </div>
      )}

      <div className="table-container">
        <div className='event-table-header'>
          <h1 className="form-title">Manage Questions</h1>
          <button
            type="button"
            className="toggle-form-button"
            onClick={handleAddEvent}
          >
            Add new question
          </button>
        </div>
        <div className="table-wrapper">
          {isLoading ? (
            <p>Loading...</p>
          ) : (
            <table className="modern-table">
              <thead>
                <tr>
                  <th>Language</th>
                  <th>Greetings</th>
                  <th>Questions</th>
                  <th>Last Message</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {events.total === 0 ? (
                  <tr>
                    <td colSpan="5" className='no-record-message'>{events.message}</td>
                  </tr>
                ) : (
                  events?.events?.map((item) => (
                    <tr key={item._id}>
                      <td className='w-100'>{item.language}</td>
                      <td style={{ whiteSpace: 'pre-line' }}>
                        <span dangerouslySetInnerHTML={{ __html: convertLinks(item.greetings) }} />
                      </td>
                      <td>
                        <ol>
                          {item.questions.map((question, index) => (
                            <li key={index}>
                              {question.text}
                            </li>
                          ))}
                        </ol>
                      </td>
                      <td style={{ whiteSpace: 'pre-line' }}>
                        <span dangerouslySetInnerHTML={{ __html: convertLinks(item.lastMessage) }} />
                      </td>
                      <td className='w-200'>
                        <button
                          className="action-button"
                          onClick={() => handleEdit(item)}
                        >
                          <img className='action-img' src={EditIcon} alt="Edit" />
                        </button>
                        <button
                          className="action-button"
                          onClick={() => handleDelete(item._id)}
                        >
                          <img className='action-img' src={DeleteIcon} alt="Delete" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateEventForm;
